import React, { useEffect, useMemo } from 'react';
import { EuiFlexGroup } from "@elastic/eui";
import '../styles.css';
import { NavGroupItemSelection } from '../Components/NavGroupItem';


export const SociedadSidebarScreen = (props:any) =>{
    
    const {data, onClick, selection,admExpatriados} = props;

    const getItems = useMemo(()=> data && data.map((soc:any, pos:number)=>(
        <NavGroupItemSelection data={soc} isSelected={selection && soc.idSociedad===selection.idSociedad} 
        onSelection={onClick} isFirst={pos===0} admExpatriados={admExpatriados}/>
    )),[data,selection,onClick,admExpatriados])


    return (
        <EuiFlexGroup direction='column' style={{height:'100%',overflow:'auto', margin:'0.5rem'}} gutterSize='s'>
            <>{getItems}</>
        </EuiFlexGroup>
    )
}